"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _styles = require("./styles");

var ContainerClickOutside =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ContainerClickOutside, _Component);

  function ContainerClickOutside() {
    (0, _classCallCheck2["default"])(this, ContainerClickOutside);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ContainerClickOutside).apply(this, arguments));
  }

  (0, _createClass2["default"])(ContainerClickOutside, [{
    key: "handleClickOutside",
    value: function handleClickOutside(e) {
      e.preventDefault();
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(_styles.Container, this.props);
    }
  }]);
  return ContainerClickOutside;
}(_react.Component);

var EnhancedContainer = (0, _reactClickOutside["default"])(ContainerClickOutside);

var Modal =
/*#__PURE__*/
function (_Component2) {
  (0, _inherits2["default"])(Modal, _Component2);

  function Modal() {
    (0, _classCallCheck2["default"])(this, Modal);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Modal).apply(this, arguments));
  }

  (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var html = document.getElementsByTagName('html')[0];
      html.classList.add('js-no-scroll');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var html = document.getElementsByTagName('html')[0];
      html.classList.remove('js-no-scroll');
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _jsx2["default"])(_styles.Background, {
        onClick: function onClick(e) {
          e.preventDefault();
        }
      }, void 0, (0, _jsx2["default"])(EnhancedContainer, {
        onClose: this.props.onClose,
        onClick: function onClick(e) {
          e.preventDefault();
        }
      }, void 0, this.props.children));
    }
  }]);
  return Modal;
}(_react.Component);

Modal.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  justifyContent: _propTypes["default"].string,
  mobileKeyboard: _propTypes["default"].bool,
  closeIconColor: _propTypes["default"].string
};
var _default = Modal;
exports["default"] = _default;